import { MapPin, Phone, Clock, Award, Users, Wrench } from 'lucide-react';

const ABOUT_IMAGE = "/images/IMG_1675.jpg";

const stats = [
  { icon: Award, value: "15+", label: "Años de Experiencia" },
  { icon: Users, value: "5000+", label: "Clientes Satisfechos" },
  { icon: Wrench, value: "10K+", label: "Reparaciones Realizadas" },
];

const AboutSection = () => {
  return (
    <section 
      id="about" 
      className="py-20 md:py-32 bg-zinc-900"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image Column */}
          <div className="relative">
            <div className="relative overflow-hidden">
              <img 
                src={ABOUT_IMAGE} 
                alt="MV Auto Expert Workshop" 
                className="w-full h-[500px] object-cover"
                data-testid="about-image"
              />
              {/* Red accent overlay */}
              <div className="absolute bottom-0 left-0 w-full h-1/3 bg-gradient-to-t from-blue-600/30 to-transparent" />
            </div>
            
            {/* Floating Stats Card */}
            <div className="absolute -bottom-8 -right-4 lg:right-8 bg-zinc-950 border border-zinc-800 p-6 shadow-2xl">
              <div className="flex gap-8">
                {stats.map((stat, index) => {
                  const Icon = stat.icon;
                  return (
                    <div key={index} className="text-center">
                      <Icon className="text-yellow-400 mx-auto mb-2" size={24} />
                      <div 
                        className="text-3xl font-black text-white"
                        style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
                      >
                        {stat.value}
                      </div>
                      <div className="text-xs text-zinc-500 uppercase tracking-wider">
                        {stat.label}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {/* Content Column */}
          <div className="lg:pl-8">
            <span 
              className="text-xs font-bold uppercase tracking-[0.2em] text-yellow-400 mb-4 block"
              style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
            >
              Sobre Nosotros
            </span>
            
            <h2 
              className="text-4xl sm:text-5xl font-bold uppercase tracking-tight text-white mb-6"
              style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
              data-testid="about-title"
            >
              Experiencia y Confianza en Cada Reparación
            </h2>
            
            <p className="text-zinc-400 text-lg mb-6 leading-relaxed">
              En <span className="text-white font-semibold">MV Auto Expert</span>, nos especializamos en brindar 
              servicios de mecánica automotriz de la más alta calidad. Nuestro equipo de técnicos certificados 
              cuenta con años de experiencia trabajando con todo tipo de vehículos, tanto domésticos como importados.
            </p>
            
            <p className="text-zinc-400 mb-8 leading-relaxed">
              Desde reconstrucciones de transmisiones hasta diagnósticos computarizados avanzados, 
              utilizamos tecnología de punta y equipos especializados para garantizar que su vehículo 
              reciba el mejor servicio posible.
            </p>

            {/* Contact Info */}
            <div className="space-y-4 mb-8">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-blue-600/20 border border-blue-600/40 flex items-center justify-center flex-shrink-0">
                  <MapPin className="text-yellow-400" size={22} />
                </div>
                <div>
                  <h4 
                    className="text-lg font-bold uppercase text-white"
                    style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
                  >
                    Ubicación
                  </h4>
                  <p className="text-zinc-400" data-testid="about-address">
                    280 W Clinton St.<br />Dover, NJ 07801
                  </p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-blue-600/20 border border-blue-600/40 flex items-center justify-center flex-shrink-0">
                  <Phone className="text-yellow-400" size={22} />
                </div>
                <div>
                  <h4 
                    className="text-lg font-bold uppercase text-white"
                    style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
                  >
                    Teléfono / WhatsApp
                  </h4>
                  <a 
                    href="tel:+18628327369" 
                    className="text-zinc-400 hover:text-yellow-400 transition-colors"
                    data-testid="about-phone"
                  >
                    +1 (862) 832-7369
                  </a>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-blue-600/20 border border-blue-600/40 flex items-center justify-center flex-shrink-0">
                  <Clock className="text-yellow-400" size={22} />
                </div>
                <div>
                  <h4 
                    className="text-lg font-bold uppercase text-white"
                    style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
                  >
                    Horario
                  </h4>
                  <p className="text-zinc-400">
                    Lunes - Viernes: 8:00 AM - 6:00 PM<br />
                    Sábado: 9:00 AM - 3:00 PM
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
